import { configureStore } from '@reduxjs/toolkit';
import authSlice from './reducers/authSlice';
import contratosSlice from '../pages/dashboard/contratosCat/contratosSlice.js';
import cuponesSlice from '../pages/dashboard/cuponesCat/CuponesSlice.js';
import indicesSlice from '../pages/dashboard/indicesCat/indicesSlice.js';
import pagosSlice from '../pages/dashboard/pagosCat/pagosSlice.js'
import noticiasSlice from '../pages/dashboard/noticiasCat/noticiasSlice.js'
import rolesSlice from '../pages/dashboard/rolesCat/rolesSlice.js'
import personasSlice from '../pages/dashboard/personasCat/personasSlice.js'
import titularidadesSlice from '../pages/dashboard/titularidadesCat/titularidadesSlice.js'
import cobranzasSlice from '../pages/dashboard/cobranzasCat/cobranzasSlice.js'
import comisionesSlice from '../pages/dashboard/comisionesCat/ComisionesCatSlice.js'
import {apiSlice} from './api/apiSlice';
//import websocketMiddleware from '../redux/middleware/websocketMiddleware.js';


const store = configureStore({
  reducer: {
    auth: authSlice,
    [apiSlice.reducerPath]: apiSlice.reducer,
    contratos: contratosSlice,
    cupones: cuponesSlice,
    indices: indicesSlice,
    pagos: pagosSlice,
    noticias: noticiasSlice,
    roles: rolesSlice,
    personas: personasSlice,
    titularidades: titularidadesSlice,
    cobranzas: cobranzasSlice,
    comisiones: comisionesSlice
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(apiSlice.middleware)//.concat(websocketMiddleware)
})

export default store;